import { render, staticRenderFns } from "./DraggableTree.vue?vue&type=template&id=59651cda&scoped=true&"
import script from "./DraggableTree.vue?vue&type=script&lang=js&"
export * from "./DraggableTree.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTree.vue?vue&type=style&index=0&id=59651cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59651cda",
  null
  
)

export default component.exports